<h1>Manage Instructions</h1>
@defer (when gridData) {
  @if (gridData.length > 0) {
    <instruction-table [gridData]="gridData"/>
  }
  @if (gridData.length === 0 && !isLoading) {
    <div class="statement">
      <span>You have no instructions available</span>
      <button matButton="filled" type="button" (click)="onCreate()">Create an instruction</button>
    </div>
  }
} @loading {
  <div class="statement"><span>Loading instructions...</span></div>
} @error {
  <div class="statement"><span>Error loading instructions</span></div>
} @placeholder () {
  <div class="statement"><span>Manage Instructions</span></div>
}
